// Central brand tokens — change ONLY here to rebrand the whole app.
export const PRODUCT_NAME = "TUPU";           // marca madre
export const PRODUCT_SUBNAME = "Calidad";     // producto / descriptor
export const PRODUCT_FULL = "TUPU Calidad";
export const DESCRIPTOR = "Controles · Registros · Evidencia · Cumplimiento";

// Official logo (PNG) — rendered as image, never recreated in CSS/text.
export const LOGO_URL = "/tupu-logo.png";
